import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { rootReducer } from "./reducerManager";

const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "noticeTemplateGenerater/getNoticeTemplatesByOrganization/fulfilled",
          "noticeTemplateGenerater/generateNoticesFromTemplate/fulfilled",
        ],
        ignoredActionPaths: [
          "meta.arg",
          "payload.data",
          "payload.headers",
          "payload.blob",
        ],
        ignoredPaths: [
          "boardsAndPanel.documentView",
          "noticeTemplateGenerater.generatedFile",
        ],
        warnAfter: 128,
      },
    }),
});
export default store;
